import React, {Component} from 'react';

/**
 *  type: PropTypes.string,
 *  payload: PropTypes.array,
 *  label: PropTypes.string,
 */
class ToolTipStitches extends Component {

    // constructor(props) {
    //     super(props);

        // this.api = new Api();
        // this.state = {activeIndex: null};

        // this.handleClick = this.handleClick.bind(this);
    // }

    render() {

        const {active, translate} = this.props;

        if (active) {
            const {payload, label} = this.props;

            if (!payload || payload.length < 2) return null;

            const stitches = parseInt(payload[0].value, 10);
            const tbs = parseInt(payload[1].value, 10);

            if (stitches === 0 && tbs === 0) return null; // Don't display tooltip if no data available

            const txtStitches = stitches.toLocaleString();
            const stitchColor = payload[0].color;
            const txtTbs = tbs > 0 ? <div style={{color: payload[1].color}}>{translate('threadbreaks')}: {tbs.toLocaleString()}</div> : '';

            let tbsPerStitches = null;

            if (stitches > 0 && tbs > 0) {
                let val = Math.round(tbs * 1000000 / stitches);

                val /= 100;
                val = val.toLocaleString(undefined, {minimumFractionDigits: 2});

                tbsPerStitches = <div style={{color: payload[1].color}}>{translate('threadbreaks')} @ 10000 {translate('stitches')}: {val}</div>
            }

            return (
                <div className="custom-tooltip">
                    <p>{(label)}</p>

                    <div style={{color: stitchColor}}>{translate('stitches')}: {(txtStitches)}</div>
                    {txtTbs}
                    {tbsPerStitches}
                </div>
            );
        }

        return null;

    }

}

export default ToolTipStitches;